import FadeEffect from "./fadeEffect";
var WmTool = /** @class */ (function () {
    function WmTool() {
    }
    // 手机号验证
    WmTool.isPhoneNo = function (val) {
        var pattern = /^1[3456789]\d{9}$/;
        return pattern.test(val);
    };
    // 邮箱验证
    WmTool.isMail = function (val) {
        var pattern = /^[A-Za-z0-9_-]+([_\.][A-Za-z0-9]+)*@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        return pattern.test(val);
    };
    // 时间戳转换
    WmTool.timestampToTime = function (timestamp) {
        var date = new Date(Number(timestamp)); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
        var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
        var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
        var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        return Y + M + D + h + m + s;
    };
    // 生成随机字符串
    WmTool.randomString = function (length) {
        var str = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
        var result = '';
        for (var i = length; i > 0; --i)
            result += str[Math.floor(Math.random() * str.length)];
        return result;
    };
    //产品列表搜索，根据产品id
    WmTool.dealList = function (arr, id) {
        var list;
        for (var i = 0; i < arr.length; i++) {
            if (arr[i].g_id == id) {
                list = arr[i];
                break;
            }
        }
        return list;
    };
    // 标签选择 HTMLSelectElement
    WmTool.$_select = function (mianEle, ele) {
        var res = mianEle.querySelector(ele);
        return res;
    };
    // 标签选择 HTMLSelectElement
    WmTool.$_selectAll = function (mianEle, ele) {
        var res = mianEle.querySelectorAll(ele);
        return res;
    };
    // 标签选择 HTMLInputElement
    WmTool.$_input = function (mianEle, ele) {
        var res = mianEle.querySelector(ele);
        return res;
    };
    //对象按键值排序
    WmTool.objKeySort = function (arys) {
        var newkey = Object.keys(arys).sort();
        var newObj = {};
        for (var i = 0; i < newkey.length; i++) {
            //遍历newkey数组
            newObj[newkey[i]] = arys[newkey[i]];
        }
        return newObj;
    };
    /**
     * 获取url中的参数值
     */
    WmTool.getUrlParam = function (url) {
        try {
            var theRequest = new Object();
            var str = url.split('?')[1].substr(0);
            var strs = str.split("&");
            for (var i = 0; i < strs.length; i++) {
                theRequest[strs[i].split("=")[0]] = (strs[i].split("=")[1]);
            }
            return theRequest;
        }
        catch (e) {
            return false;
        }
    };
    /**
     * 复制文本到剪贴板
     * @param text 要复制的文本内容
     * @return Promise
     */
    WmTool.copyToClipboard = function (text) {
        if (!text || !text.trim()) {
            return Promise.reject(new Error('复制内容为空'));
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
            return navigator.clipboard.writeText(text.trim());
        }
        else {
            var textarea = document.createElement('textarea');
            textarea.value = text.trim();
            document.body.appendChild(textarea);
            textarea.select();
            try {
                document.execCommand('copy');
                return Promise.resolve();
            }
            catch (err) {
                return Promise.reject(err);
            }
            finally {
                document.body.removeChild(textarea);
            }
        }
    };
    WmTool.showToast = function (text, duration, type) {
        if (duration === void 0) { duration = 2000; }
        if (type === void 0) { type = 'success'; }
        if (!toast) {
            toast = document.getElementById('toast');
        }
        if (this.currentTimer) {
            clearTimeout(this.currentTimer);
        }
        if (toast) {
            toast.textContent = text;
            toast.className = "toast ".concat(type);
            FadeEffect.fadeIn(toast);
            this.currentTimer = window.setTimeout(function () {
                FadeEffect.fadeOut(toast);
            }, duration);
        }
        else {
            console.error('Toast element error');
        }
    };
    /**
   * 安全地从嵌套对象中获取指定路径的属性值。
   * 如果路径中的任意一级属性不存在，将返回 `undefined` 而不会抛出错误。
   *
   * @param obj - 源对象，可以是任意嵌套结构的对象或 `null`/`undefined`
   * @param path - 属性路径，使用点号（`.`）分隔的字符串，如 `'user.profile.phone'`
   * @returns 对应路径的属性值；如果路径无效或中间属性不存在，则返回 `undefined`
   *
   * @example
   * ```ts
   * const user = {
   *   profile: {
   *     contact: {
   *       phone: '13800138000'
   *     }
   *   }
   * };
   *
   * Tool.getNestedValue(user, 'profile.contact.phone'); // '13800138000'
   * Tool.getNestedValue(user, 'profile.settings.theme'); // undefined
   * Tool.getNestedValue(null, 'name'); // undefined
   * Tool.getNestedValue(user, 'orders.0.amount'); // 支持数组索引
   * ```
   */
    WmTool.getNestedValue = function (obj, path) {
        return path.split('.').reduce(function (acc, part) { return acc && acc[part]; }, obj);
    };
    /**
     * 显示提示信息(注意样式和html结构需要自行定义,可参考findMemberAccount.html)
     * @param text 提示文本
     * @param duration 显示时长，默认2秒
     * @param type 提示类型，'success' 或 'error'，默认'success'
     */
    // 注意：toast样式和HTML结构需要自己定义，可参考findMemberAccount.html中的toast元素和样式
    WmTool.currentTimer = null;
    return WmTool;
}());
export default WmTool;
